import {
    EDIT_PROJECT_RESET,
    EDIT_PROJECT_GENERALES,
    EDIT_PROJECT_HIGH_FREQUENCY,
    EDIT_PROJECT_HEALTH_CHECK
} from "../redux-const";

const initialState = {
    loading: false,
    tab: 0,
    new: true,
    name: "",
    tag: "",
    tagColor: "gray",
    tags: [{
        "name": "prod",
        "color": "red"
    }, {
        "name": "dev",
        "color": "blue"
    }, {
        "name": "test",
        "color": "green"
    }],
    showDeleteDialog: {
        open: false
    },
    tokens: [],
    activeVerificationConfig: {
        showUpdateDialog: false,
        verificationMethod: "NONE",
        keystoreBase64: "",
        keystorePassword: "",
        keyAlias: ""
    },
    highFrequency: {
        enabled: false,
        maxUpdates: 100,
        timeWindow: 1000,
        timeWindowUnit: "SECONDS",
        cooldown: 1000,
        cooldownUnit: "SECONDS",
    },
    healthCheck: {
        enabled: false,
        threshold: 1000,
        thresholdUnit: "SECONDS",
    }
}


export const reducer = (state = initialState, action) => {
    const payload = action.payload;

    switch (action.type) {
        case EDIT_PROJECT_GENERALES:
            return {
                ...state,
                ...payload
            }
        case EDIT_PROJECT_RESET:
            return initialState
        case EDIT_PROJECT_HIGH_FREQUENCY:
            return {
                ...state,
                highFrequency: {
                    ...payload
                }
            }
        case EDIT_PROJECT_HEALTH_CHECK:
            return {
                ...state,
                healthCheck: {
                    ...payload
                }
            }
        default:
            return state
    }
};

export default reducer;
